import {ReactNode} from 'react';

type Props = {
  type: 'error' | 'success';
  children: ReactNode;
};

export default function ShippingLineItem({type, children}: Props) {
  const additionalClasses = type === 'error' ? 'richH7 font-bold mt-8' : '';

  return (
    <div
      className={`flex items-start gap-x-2 md:items-center ${additionalClasses}`}
    >
      {type === 'error' && (
        <svg
          className="inline"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1728 4.40687C17.6091 3.97065 17.6091 3.26339 17.1728 2.82717C16.7366 2.39094 16.0293 2.39094 15.5931 2.82717L10 8.42029L4.40687 2.82717C3.97065 2.39094 3.26339 2.39094 2.82717 2.82717C2.39094 3.26339 2.39094 3.97065 2.82717 4.40687L8.42029 10L2.82717 15.5931C2.39094 16.0293 2.39094 16.7366 2.82717 17.1728C3.26339 17.6091 3.97065 17.6091 4.40687 17.1728L10 11.5797L15.5931 17.1728C16.0293 17.6091 16.7366 17.6091 17.1728 17.1728C17.6091 16.7366 17.6091 16.0293 17.1728 15.5931L11.5797 10L17.1728 4.40687Z"
            fill="#FF0000"
          />
        </svg>
      )}
      {type === 'success' && (
        <svg
          className="w-5"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4353 4.06323C18.8549 4.48088 18.8549 5.15801 18.4353 5.57566L7.68965 16.2701C7.27001 16.6877 6.58964 16.6877 6.16999 16.2701L1.56473 11.6868C1.14509 11.2691 1.14509 10.592 1.56473 10.1743C1.98437 9.7567 2.66475 9.7567 3.08439 10.1743L6.92982 14.0015L16.9156 4.06323C17.3352 3.64559 18.0156 3.64559 18.4353 4.06323Z"
            fill="#08BE25"
          />
        </svg>
      )}
      {children}
    </div>
  );
}
